import tools from "../../../../assets/javascript/tools.js";
export default {
    columns: {
        categoryName: {
            label: "修护项目",
            visible: true,
            width: "auto",
            align: "left",
        },
        recordTime: {
            label: "建档时间",
            visible: true,
            formatDay: true,
            width: "auto",
            align: "left",
        },
        documentTotal: {
            label: "档案数量",
            visible: true,
            minWidth: "100",
            align: "left",
        },
    },
};